import { Separator } from '@radix-ui/react-dropdown-menu';

interface InsuranceCardProps {
  id?: number;
  name: string;
  description?: string | null;
  logo: string;
  className?: string;
}

export default function InsuranceCard({ id, name, description, logo, className = '' }: InsuranceCardProps) {
  return (
    <div
      key={id}
      className={`${className} text-start h-72 bg-white cursor-pointer flex flex-col justify-center items-center shadow-md rounded-lg overflow-hidden relative group`}
    >
      <img
        src={logo}
        alt={name}
        className="w-44 h-24 object-contain m-3 object-center transition-opacity duration-300 group-hover:opacity-0"
      />
      <div className="flex flex-col gap-1 px-4 py-2 w-full">
        <div className="flex justify-between items-center">
          <h2 className="font-medium whitespace-nowrap overflow-hidden text-ellipsis">{name}</h2>
        </div>
        <Separator />
        <p className="text-sm line-clamp-5">{description}</p>
      </div>

      <div className="absolute inset-0 bg-white bg-opacity-90 flex flex-col overflow-hidden justify-center items-center p-4 h-0 opacity-0 group-hover:h-full group-hover:opacity-100 transition-all duration-300">
        <h2 className="font-medium text-center">{name}</h2>
        <Separator className="my-2" />
        <p className="text-sm text-center overflow-y-scroll hide-scrollbar">{description}</p>
      </div>
    </div>
  );
}
